import React, {createContext, useEffect, useState, useContext} from 'react';
import {getEmployeeTCPRoles, getEmployeePermission} from "../resources/EmployeeResource";
import Loader from "../loader/Loader";
import {SCC_AUTOMATION_MANAGER, SCC_AUTOMATION_VIEWER} from "../util/Constants";
import {GlobalStateContext} from "../global/context/GlobalStateContext";
import {FEATURES, FeatureUtility} from "../util/FeatureUtility";

export const PermissionsContext = createContext();

const PermissionsContextProvider = ({children}) => {
  const {setAsyncError, loadingFeatures} = useContext(GlobalStateContext);
  const [isAuthorised, setIsAuthorised] = useState(false);
  const [isManager, setIsManager] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(true);

  useEffect(() => {
    (async () => {
      const tcpRolesResponse = await getEmployeeTCPRoles();
      if(tcpRolesResponse.includes(SCC_AUTOMATION_VIEWER) || tcpRolesResponse.includes(SCC_AUTOMATION_MANAGER)) {
        setIsAuthorised(true);
      } else {
        // this is temporary change. this logic should be shifted to backend
        setAsyncError("You're not authorised to access this page. Please review your permissions.");
      }
      if(tcpRolesResponse.includes(SCC_AUTOMATION_MANAGER)) {
        setIsManager(true);
      }

      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
    if(FeatureUtility.getFeatureStatus(FEATURES.IS_DMW_PERMISSIONS_ENABLED)){
      const isPermission = await getEmployeePermission();
      setIsAuthorized(isPermission);
    }
    })();
  }, [loadingFeatures]);

  if(isLoading) return <Loader />;
  return <PermissionsContext.Provider value={{isAuthorised, isManager, isAuthorized}}>{children}</PermissionsContext.Provider>
}

export default PermissionsContextProvider;


// WEBPACK FOOTER //
// ./src/components/permissions/PermissionsContext.js